export default __webpack_public_path__ + "images/assets/8850d5d367a34d781e83566af93182ab.svg";